// Copyright (c) 2016 Deere & Company

import PartsClaimContainer from '../../claim/parts/state-connector';

export default {
    component: PartsClaimContainer,
    name: 'PARTS',
    path: 'parts/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/parts-claim-route.js